import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";

const Header = ({ onSearchChange, onCategoryChange, activeCategory, searchTerm }) => {
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [balance, setBalance] = useState(null);
  const { user, logout, getFreshToken } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/categorias`);
        setCategories(response.data);
      } catch (error) {
        console.error("Erro ao buscar categorias:", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchBalance = async () => {
      if (user) {
        try {
          // Obtém token fresco diretamente do AuthContext
          const token = await getFreshToken();

          if (token) {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/wallet/balance`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            setBalance(response.data.balance);
          }
        } catch (error) {
          console.error("Erro ao buscar saldo:", error);
        }
      }
    };
    fetchBalance();
  }, [user]);

  const handleSearch = (e) => {
    onSearchChange(e.target.value);
  };

  const handleLogoClick = () => {
    // Força o recarregamento voltando para a Home
    window.location.href = '/';
  };

  return (
    <header style={{ backgroundColor: 'var(--secondary-color)', boxShadow: 'var(--shadow-sm)' }}>
      {/* GoogleOneTap removed from here, moved to App.js */}
      <div className="container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '70px', padding: '10px 0' }}>
          {/* Logo */}
          <div
            onClick={handleLogoClick}
            style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', marginRight: 'var(--spacing-lg)', cursor: 'pointer' }}
          >
            <img src="/logo-ofertiz.png" alt="Ofertiz" style={{ height: '65px', width: 'auto', filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25))' }} />
          </div>

          {/* Search Bar - Desktop & Mobile */}
          <div style={{ flex: 1, maxWidth: '600px', margin: '0 var(--spacing-md)' }}>
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: 'var(--white)', borderRadius: 'var(--radius-sm)', padding: '8px 12px', boxShadow: 'var(--shadow-sm)' }}>
              <i className="fas fa-search" style={{ color: 'var(--text-secondary)' }}></i>
              <input
                type="text"
                placeholder="Buscar ofertas, marcas e muito mais..."
                value={searchTerm || ""}
                onChange={handleSearch}
                style={{ border: 'none', outline: 'none', width: '100%', marginLeft: '8px', fontSize: 'var(--font-size-base)' }}
              />
            </div>
          </div>

          {/* User Actions */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
            {user ? (
              <div
                style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 'var(--spacing-sm)', cursor: 'pointer', padding: '5px 0' }}
                onMouseEnter={() => setShowUserMenu(true)}
                onMouseLeave={() => setShowUserMenu(false)}
              >
                {/* Points Display */}
                <div style={{
                  marginRight: '10px',
                  padding: '4px 10px',
                  backgroundColor: '#fff3cd',
                  color: '#856404',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  border: '1px solid #ffeeba'
                }}>
                  <i className="fas fa-coins"></i>
                  {balance !== null ? balance : '...'}
                </div>

                {user.photoURL && (
                  <img
                    src={user.photoURL}
                    alt="Perfil"
                    style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #ddd' }}
                  />
                )}
                <span style={{ fontSize: 'var(--font-size-sm)', color: '#2d3277' }}>Olá, {user.name || user.email.split('@')[0]}</span>
                <i className="fas fa-chevron-down" style={{ fontSize: '10px', color: '#2d3277' }}></i>

                {/* User Dropdown */}
                {showUserMenu && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    boxShadow: 'var(--shadow-md)',
                    borderRadius: 'var(--radius-sm)',
                    padding: '10px',
                    zIndex: 1000,
                    minWidth: '150px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    border: '1px solid var(--border-color)'
                  }}>
                    <Link
                      to="/perfil"
                      style={{
                        padding: '8px 12px',
                        color: 'var(--text-primary)',
                        textDecoration: 'none',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        borderRadius: '4px'
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <i className="fas fa-user-circle"></i> Minha Conta
                    </Link>
                    <Link
                      to="/carteira"
                      style={{
                        padding: '8px 12px',
                        color: 'var(--text-primary)',
                        textDecoration: 'none',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        borderRadius: '4px'
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <i className="fas fa-wallet"></i> Minha Carteira
                    </Link>
                    <button
                      onClick={logout}
                      style={{
                        background: 'none',
                        border: 'none',
                        textAlign: 'left',
                        padding: '8px 12px',
                        color: '#d32f2f',
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        borderRadius: '4px',
                        width: '100%'
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#ffebee'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <i className="fas fa-sign-out-alt"></i> Sair
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" style={{ fontSize: 'var(--font-size-sm)', color: '#2d3277', fontWeight: '500' }}>
                Entre ou cadastre-se
              </Link>
            )}
            <Link to="/favoritos" style={{ color: '#2d3277', fontSize: '18px' }}>
              <i className="far fa-heart"></i>
            </Link>
          </div>
        </div>

        {/* Categories - Dropdown Menu */}
        <div style={{ position: 'relative', marginTop: '0' }}>
          <div style={{ 
            display: 'flex', 
            gap: 'var(--spacing-md)', 
            paddingBottom: '5px', 
            flexWrap: 'nowrap', // Force single line
            alignItems: 'center'
          }}>
            <Link to="/blog" style={{
              textDecoration: 'none',
              color: location.pathname === '/blog' ? '#2d3277' : 'var(--text-secondary)',
              fontWeight: location.pathname === '/blog' ? 'bold' : 'normal',
              fontSize: 'var(--font-size-sm)',
              padding: '8px 0',
              borderBottom: location.pathname === '/blog' ? '2px solid #2d3277' : '2px solid transparent',
              whiteSpace: 'nowrap'
            }}>
              Blog
            </Link>
            
            {/* Main Categories (First 8) */}
            {categories.slice(0, 8).map((cat) => (
              <div
                key={cat.id}
                onMouseEnter={() => setHoveredCategory(cat.id)}
                onMouseLeave={() => setHoveredCategory(null)}
                style={{ position: 'relative' }}
              >
                <button
                  onClick={() => onCategoryChange(cat.name, null)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: activeCategory === cat.name ? '#2d3277' : 'var(--text-secondary)',
                    fontWeight: activeCategory === cat.name ? 'bold' : 'normal',
                    fontSize: 'var(--font-size-sm)',
                    cursor: 'pointer',
                    padding: '8px 0',
                    borderBottom: activeCategory === cat.name ? '2px solid #2d3277' : '2px solid transparent',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {cat.name} {cat.subcategories && cat.subcategories.length > 0 && <i className="fas fa-chevron-down" style={{ fontSize: '10px', marginLeft: '4px' }}></i>}
                </button>

                {/* Subcategories Dropdown */}
                {hoveredCategory === cat.id && cat.subcategories && cat.subcategories.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    backgroundColor: 'white',
                    boxShadow: 'var(--shadow-md)',
                    borderRadius: 'var(--radius-sm)',
                    padding: '10px',
                    zIndex: 1000,
                    minWidth: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    border: '1px solid var(--border-color)'
                  }}>
                    {cat.subcategories.map((sub) => (
                      <button
                        key={sub.id}
                        onClick={() => {
                          onCategoryChange(cat.name, sub.name);
                          setHoveredCategory(null);
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          textAlign: 'left',
                          padding: '8px 12px',
                          color: 'var(--text-primary)',
                          fontSize: '14px',
                          cursor: 'pointer',
                          borderRadius: '4px',
                          transition: 'background-color 0.2s',
                          width: '100%'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                      >
                        {sub.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {/* "Mais Categorias" Dropdown */}
            {categories.length > 8 && (
              <div
                onMouseEnter={() => setHoveredCategory('more')}
                onMouseLeave={() => setHoveredCategory(null)}
                style={{ position: 'relative' }}
              >
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    color: hoveredCategory === 'more' ? '#2d3277' : 'var(--text-secondary)',
                    fontWeight: hoveredCategory === 'more' ? 'bold' : 'normal',
                    fontSize: 'var(--font-size-sm)',
                    cursor: 'pointer',
                    padding: '8px 0',
                    borderBottom: hoveredCategory === 'more' ? '2px solid #2d3277' : '2px solid transparent',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Mais Categorias <i className="fas fa-chevron-down" style={{ fontSize: '10px', marginLeft: '4px' }}></i>
                </button>

                {hoveredCategory === 'more' && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    boxShadow: 'var(--shadow-md)',
                    borderRadius: 'var(--radius-sm)',
                    padding: '10px',
                    zIndex: 1000,
                    minWidth: '220px',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    border: '1px solid var(--border-color)'
                  }}>
                    {categories.slice(8).map((cat) => (
                      <div key={cat.id} style={{ position: 'relative' }} className="more-category-item">
                        <button
                          onClick={() => onCategoryChange(cat.name, null)}
                          style={{
                            background: 'none',
                            border: 'none',
                            textAlign: 'left',
                            padding: '8px 12px',
                            color: 'var(--text-primary)',
                            fontSize: '14px',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                          {cat.name}
                          {cat.subcategories && cat.subcategories.length > 0 && <i className="fas fa-chevron-right" style={{ fontSize: '10px' }}></i>}
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </header >
  );
};

export default Header;
